import React, { useState, useEffect } from "react";
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { Box } from "@mui/material/";
import { ActionIcon, Tooltip } from '@mantine/core';


const StoryboardLinkButton = ({ projectKey, preview, iconColour }) => {

    const [show, setShow] = useState(false);
    const [showText, setShowText] = useState(false);
    const [divWidth, setDivWidth] = useState(60);
    const [hover, setHover] = useState(false);

    useEffect(() => {
        show ? setDivWidth(120) : setDivWidth(60)
    })

    const handleClose = () => {
        setShow(false);
        setShowText(false);
    };

    return (!preview ? <>
            <Tooltip label="Export storyboards"><ActionIcon
                component='a'
                href={`/storyboard-editor/${projectKey}`}
                target="_blank"
                variant="transparent"
                color={iconColour.normal}
                c={!hover ? iconColour.normal : iconColour.hover}
                onPointerOver={() => setHover(true)}
                onPointerLeave={() => setHover(false)}
                aria-label="View storyboard">
                <ImageOutlinedIcon style={{ width: '80%', height: '80%' }}/>
            </ActionIcon></Tooltip>
    </>
        :
        <>

            
                <ActionIcon
                 
                    component='a'
                    href={`/${projectKey}`}
                    target="_blank"
                    variant="transparent"
                    color={iconColour.normal}
                    aria-label="View storyboard">
                    <ImageOutlinedIcon style={{ width: '80%', height: '80%' }}/>
                </ActionIcon>





        </>)
};

export default StoryboardLinkButton;
